<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="card-container">
    <div class="kpis-summary">
      <div v-for="kpi in categorizedKpis" :key="kpi.category" class="card">
        <div class="card-title">{{ kpi.category }}</div>
        <v-divider></v-divider>
        <div class="card-content custom-scrollbar">
          <ul class="kpi-list">
            <EcsBusinessProcessMonitoringKpiItem
              v-for="item in kpi.items"
              :key="item.id"
              :item="item"
              :business-process-id="businessProcessId"
            />
          </ul>
        </div>
      </div>
    </div>
    <EcsAgentStatesSummaryBar
      :business-process-id="businessProcessId"
      :dark="$vuetify.theme.dark"
      @filter-agents="filter"
    />
    <div class="health-configuration-container">
      <div class="health-configuration-options">
        <v-select
          v-model="selectedHealthConfiguration"
          :items="businessProcessHealthConfigurationTemplates"
          item-value="_id"
          :label="$t('labels.healthConfiguration')"
          item-text="name"
          :height="26"
          hide-details
          attach
          class="health-configuration-input"
        >
        </v-select>
      </div>
    </div>
  </div>
</template>

<script>
import EcsBusinessProcessHealthMixins from '@/mixins/ecs-business-process-health/EcsBusinessProcessHealthMixins';
import EcsBusinessProcessMonitoringKpiItem from '@/components/ecs-business-process-monitoring-card/EcsBusinessProcessMonitoringKpiItem';
import EcsAgentStatesSummaryBar from '@/components/ecs-business-process-monitoring-card/EcsAgentStatesSummaryBar/EcsAgentStatesSummaryBar';

export default {
  name: 'EcsBusinessProcessMonitoringOrganizedDataCard',

  components: {
    EcsAgentStatesSummaryBar,
    EcsBusinessProcessMonitoringKpiItem
  },

  mixins: [EcsBusinessProcessHealthMixins],

  props: {
    businessProcessId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      selectedHealthConfiguration: 0
    };
  },

  computed: {
    categorizedKpis() {
      return [
        {
          category: 'Volume',
          items: this.volumeKpis
        },
        {
          category: 'Reactivity',
          items: this.reactivityKpis
        },
        {
          category: 'Callbacks',
          items: this.callbacksKpis
        }
      ];
    },

    volumeKpis() {
      const interactionKpis = this.kpis.businessProcessTotalInteractions;
      const answeredInteractionsKpi = this.kpis.businessProcessAnsweredInteractions;
      answeredInteractionsKpi.percentage = this.kpis.businessProcessAnsweredPercentage;
      const abandonedInteractionsKpi = this.kpis.businessProcessAbandonedInteractions;
      abandonedInteractionsKpi.percentage = this.kpis.businessProcessAbandonedPercentage;

      interactionKpis.kpis = [
        answeredInteractionsKpi,
        this.kpis.businessProcessOverflowInteractions,
        abandonedInteractionsKpi
      ];

      return [
        interactionKpis,
        this.kpis.businessProcessVoiceMails,
        this.kpis.businessProcessTotalInternalTransferredOut,
        this.kpis.businessProcessTotalExternalTransferredOut,
        this.kpis.businessProcessDNCRequestsInShift
      ];
    },

    reactivityKpis() {
      const waitingInteractions = this.kpis.businessProcessWaitingInteractions;
      waitingInteractions.kpis = [this.kpis.businessProcessLongestWaitingTime];

      return [
        this.kpis.businessProcessServiceLevel,
        waitingInteractions,
        this.kpis.businessProcessAverageWaitingTime,
        this.kpis.businessProcessAverageAnswerTime,
        this.kpis.businessProcessAverageAgentHandlingTime
      ];
    },

    callbacksKpis() {
      const callbacksProcessed = this.kpis.callbackProcessedInShift;
      callbacksProcessed.kpis = [
        this.kpis.callbackSuccessfulPercentageInShift,
        this.kpis.callbackFailedPercentageInShift
      ];
      return [
        this.kpis.callbackAverageHandlingTime,
        this.kpis.callbackRequestedInShift,
        callbacksProcessed,
        this.kpis.callbackToBeProcessed,
        this.kpis.callbackInteractionsPurgedInShift
      ];
    }
  },

  created() {
    this.selectedHealthConfiguration = this.businessProcessHealthConfiguration
      ? this.businessProcessHealthConfiguration._id
      : 0;
  },

  methods: {
    filter(data) {
      this.$parent.setCurrentTab(0, data);
    }
  }
};
</script>

<style scoped>
.card-container {
  display: grid;
  grid-template-rows: auto 36px;
  height: 100%;
  padding: 0 8px;
}

.kpis-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 2px;
  height: 100%;
}

.card {
  overflow: hidden;
}

.card-title {
  padding: 2px 4px;
  font-size: 16px;
}

.card-content {
  height: calc(100% - 16px);
  padding: 4px 2px;
  font-size: 10px;
}

.kpi-list {
  list-style-type: none;
  padding-left: 0;
}

.health-configuration-container {
  display: grid;
  grid-template-columns: 50% 50%;
  height: 100%;
  width: 100%;
  padding: 0 8px;
}

.health-configuration-options {
  display: inline-flex;
  font-size: 12px;
}

.health-configuration-label {
  line-height: 28px;
  margin-right: 8px;
}

.health-configuration-input {
  max-width: 120px;
  padding: 0;
  margin: 10px 0px;
  font-size: 12px;
}
</style>
